<div class="flex flex-col items-center px-4">
  <div class="w-full max-w-2xl mt-6 lg:w-screen">
    <h3 class="mb-6 text-xl font-bold">Status płatności</h3>
    <div class="flex justify-center text-red-600">
      <img class="error-icon" src="assets/img/error.svg" alt="Nieznany błąd" />
    </div>
    <div class="mt-6 mb-4 text-2xl text-center text-red-600">
      Coś poszło nie tak
    </div>

    <div class="mb-8 text-sm text-center text-gray-700">
      Wystąpił nieznany błąd podczas przygotowywania lub wykonywania płatności.
      <br class="hidden md:flex" />
      Spróbuj ponownie, a jeśli problem się powtarza,
      <a
        (click)="openChat()"
        class="text-gray-700 underline transition-colors duration-150 cursor-pointer hover:text-gray-500"
        >napisz do nas</a
      >.
    </div>

    <app-value-proposition [highlight]="true"></app-value-proposition>
  </div>
</div>
